import script from "./ManufacturerPriceList.vue?vue&type=script&setup=true&lang=js"
export * from "./ManufacturerPriceList.vue?vue&type=script&setup=true&lang=js"

import "./ManufacturerPriceList.vue?vue&type=style&index=0&id=a69d9182&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a69d9182"]])

export default __exports__